export default __webpack_public_path__ + "static/media/instaclone-demo.55177426.mp4";